export default __webpack_public_path__ + "static/media/shutdown-icon.cd356a49.svg";